<!--
  - Copyright (c) 2021 brightlamp
  -->

<template>
    <v-card class="mx-auto my-12" max-width="400">
        <vue-plyr ref="vuePlayer" :options="playerOptions">
            <video :src=videoUrl />
        </vue-plyr>
        <v-card-title>{{ header }}</v-card-title>
        <v-card-text>
            <div class="my-4 text-subtitle-1">{{ subHeader }}</div>
            <div>{{ text }}</div>
        </v-card-text>
        <v-btn v-if="deepDiveUrl" class="ma-4" @click="deepDive" color="accent">
            <span style="color: #000000;">Deep Dive</span>
        </v-btn>
        <v-divider class="mx-4"></v-divider>
        <v-card-title>Minimum Subscription Level</v-card-title>
        <v-chip class="ma-2" color="accent" text-color="black">{{ subLevel }}</v-chip>
        <v-divider class="mx-4"></v-divider>
        <v-card-title>Products</v-card-title>
        <template v-for="product in products">
            <v-chip class="ma-2"  color="accent" text-color="black">{{ product }}</v-chip>
        </template>
    </v-card>
</template>

<script>
    import VuePlyr from 'vue-plyr';
    import {mapState} from 'vuex';

    export default
    {
        name: 'learning-center-card',
        components:
        {
            VuePlyr
        },
        data: function ()
        {
            return {
                playerOptions:
                {
                    controls: ['play-large', 'play', 'progress', 'current-time', 'fullscreen']
                }
            }
        },
        props:
        {
            videoUrl: '',
            header: '',
            subHeader: '',
            text: '',
            subLevel: [],
            products: [],
            deepDiveUrl: ''
        },
        computed:
        {
            ...mapState('auth',
            {
                currentUser: state => state.currentUser
            })
        },
        mounted()
        {
            this.$refs.vuePlayer.player.on('play', () => this.onVideoAction('video_learning_center_play'))
            this.$refs.vuePlayer.player.on('pause', () => this.onVideoAction('video_learning_center_pause'))
        },
        methods:
        {
            onVideoAction(eventName)
            {
                this.$logEvent(this.$firebaseAnalytics,
                {
                    app_name: 'Web Portal',
                    video_title: this.header,
                    app_version: process.env.VUE_APP_VERSION,
                    uid: this.currentUser.uId
                });
            },
            deepDive()
            {
                window.open(this.deepDiveUrl, '_blank')
            }
        }
    };
</script>

<style lang="scss" rel="stylesheet/scss" scoped>
    .v-card__text, .v-card__title
    {
        word-break: normal;
    }
</style>